<template>
  <div class="feedback-toasts">
    <div
      class="toast"
      :class="{
        error: toast.type === 'error',
        success: toast.type === 'success',
        info: toast.type === 'info'
      }"
      :key="`toast_${i}`"
      v-for="(toast, i) in toasts"
    >
      <div class="text">{{ toast.text }}</div>
      <a class="close" @click="removeToast(toast)">
        <i class="fas fa-times" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "FeedbackToasts",
  computed: {
    toasts() {
      return this.$store.state.FeedbackToasts.toasts;
    }
  },
  methods: {
    removeToast(toast) {
      this.$store.commit("removeToast", toast);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../scss/assets";

.feedback-toasts {
  &:not(:empty) {
    @apply fixed bottom-0 p-5 z-50;
  }

  .toast {
    border-radius: 3px;
    box-shadow: 0 7px 7px 0 rgba(0, 0, 0, 0.2);

    @apply flex justify-between items-center p-5 bg-onyx text-white;

    @screen md {
      @apply max-w-md;
    }

    & + .toast {
      @apply mt-4;
    }

    .close {
      height: calculateRem(30);
      width: calculateRem(30);

      border-radius: 50%;

      line-height: calculateRem(32);

      @apply flex-shrink-0 ml-5 text-center;

      &:hover {
        background-color: rgba(white, 0.2);
      }
    }
  }
}
</style>
